import { render, staticRenderFns } from "./single-column-container.vue?vue&type=template&id=b5ee4f9c"
import script from "./single-column-container.vue?vue&type=script&lang=js"
export * from "./single-column-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports